// components/_pages/BrandKeeper/sections/ConsistencyFeature.jsx
import React from "react";
import "./ConsistencyFeature.scss";

// Artwork (saved with your chosen name)
import Artwork from "../../../../resources/images/brandkeeper/healthcare_social_media_ads.png";

const ConsistencyFeature = () => {
  return (
    <section className="consistency-feature" aria-label="Consistency feature">
      <div className="cf__inner">
        {/* LEFT: artwork */}
        <div className="cf__art">
          {/* Decorative image (alt intentionally empty per your direction) */}
          <img className="cf__img" src={Artwork} alt="" loading="lazy" />
        </div>

        {/* RIGHT: copy */}
        <div className="cf__copy">
          <p className="cf__kicker">Brand recognition that sticks</p>

          <h2 className="cf__title">
            Show up consistently until the market can’t ignore you.
          </h2>

          <p className="cf__lead">
            With <strong>BrandKeeper™</strong>, every ad, proposal, and social post feels unmistakably like the same business, building trust faster than any campaign while giving clients a clear reason to choose you over the competition.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ConsistencyFeature;
